import React from 'react'
import "./Trekendshi.css"
import logo from "../../Assets/logo.png"
import logoja from "../../Assets/logoja.png"


const Trekendshi = () => {
  return (
        <section class="home-section">
        <div class="triangle">
        <img id='logojaaa' src={logoja} alt="" />
        </div>
        </section>
  )
}

export default Trekendshi